import { makeStyles } from '@material-ui/core'
import { mq } from '@velocity/styling'

const PICTOGRAM_WIDTH = 172
const CONTENT_WIDTH = 560
const ACTIONS_WIDTH = 344

export const useDriverNotificationViewStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: 'var(--vel-layout-spacing-06)',
    [mq.min('LG')]: {
      paddingTop: 'calc(var(--vel-layout-spacing-06) * 2)',
    },
  },
  pictogram: {
    '&&': {
      width: PICTOGRAM_WIDTH,
      height: PICTOGRAM_WIDTH,
      marginBottom: 'var(--vel-layout-spacing-06)',
    },
  },
  headline: {
    '&&': {
      fontWeight: 'normal',
      marginBottom: 'var(--vel-fixed-spacing-05)',
    },
  },
  content: {
    '&&': {
      maxWidth: CONTENT_WIDTH,
      marginBottom: 'var(--vel-fixed-spacing-05)',
    },
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--vel-fixed-spacing-04)',
    width: '100%',
    maxWidth: ACTIONS_WIDTH,
    marginTop: 'var(--vel-fixed-spacing-05)',
  },
}))
